module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "somi-player-container"
  }, [_c('div', {
    staticClass: "somi-player-box",
    on: {
      "fullscreenchange": _vm.fullScreenChange,
      "webkitfullscreenchange": _vm.fullScreenChange,
      "mozfullscreenchange": _vm.fullScreenChange,
      "MSFullscreenChange": _vm.fullScreenChange
    }
  }, [_c('div', {
    staticClass: "somi-player-display",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "mousedown": _vm.displayMouseDown,
      "mousemove": _vm.sliderMove,
      "mouseleave": _vm.sliderLeave,
      "mouseup": _vm.sliderUp,
      "keydown": _vm.videoKeyDown,
      "contextmenu": _vm.displayContextmenu
    }
  }, [_c('div', {
    staticClass: "somi-menu",
    style: (_vm.player.menu.styleObject)
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "somi-event-div",
    on: {
      "dblclick": _vm.fullScreen,
      "click": _vm.playVideo
    }
  }, [_c('svg', {
    class: _vm.player.svgState.show,
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "-18 -19 70 70"
    },
    on: {
      "transitionend": _vm.transitionEnd,
      "transition": _vm.transitionEnd,
      "OTransition": _vm.transitionEnd,
      "MozTransition": _vm.transitionEnd
    }
  }, [_c('g', {
    staticClass: "time-back",
    attrs: {
      "transform": "scale(0.03125 0.03125)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M512 64c-141.384 0-269.376 57.32-362.032 149.978l-149.968-149.978v384h384l-143.532-143.522c69.496-69.492 165.492-112.478 271.532-112.478 212.068 0 384 171.924 384 384 0 114.696-50.292 217.636-130.018 288l84.666 96c106.302-93.816 173.352-231.076 173.352-384 0-282.77-229.23-512-512-512z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "time-ahead",
    attrs: {
      "transform": "scale(0.03125 0.03125)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 576c0 152.924 67.048 290.184 173.35 384l84.666-96c-79.726-70.364-130.016-173.304-130.016-288 0-212.076 171.93-384 384-384 106.042 0 202.038 42.986 271.53 112.478l-143.53 143.522h384v-384l-149.97 149.978c-92.654-92.658-220.644-149.978-362.030-149.978-282.77 0-512 229.23-512 512z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "video-pause",
    attrs: {
      "transform": "scale(0.03125 0.03125)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M192 128l640 384-640 384z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "video-play",
    attrs: {
      "transform": "scale(0.03125 0.03125)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M128 128h320v768h-320zM576 128h320v768h-320z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "volume-up",
    attrs: {
      "transform": "scale(0.03125 0.03125)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1024 576h-192v192h-128v-192h-192v-128h192v-192h128v192h192v128z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "volume-down",
    attrs: {
      "transform": "scale(0.03125 0.03125)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M512 448h512v128h-512v-128z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z"
    }
  })])]), _vm._v(" "), _c('svg', {
    class: _vm.player.svgState.loading,
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "-18 -19 70 70"
    }
  }, [_c('g', {
    attrs: {
      "transform": "scale(0.03125 0.03125)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M384 128c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM790.994 512c0 0 0 0 0 0 0-57.993 47.013-105.006 105.006-105.006s105.006 47.013 105.006 105.006c0 0 0 0 0 0 0 57.993-47.013 105.006-105.006 105.006s-105.006-47.013-105.006-105.006zM688.424 783.53c0-52.526 42.58-95.106 95.106-95.106s95.106 42.58 95.106 95.106c0 52.526-42.58 95.106-95.106 95.106s-95.106-42.58-95.106-95.106zM425.862 896c0-47.573 38.565-86.138 86.138-86.138s86.138 38.565 86.138 86.138c0 47.573-38.565 86.138-86.138 86.138s-86.138-38.565-86.138-86.138zM162.454 783.53c0-43.088 34.93-78.018 78.018-78.018s78.018 34.93 78.018 78.018c0 43.088-34.93 78.018-78.018 78.018s-78.018-34.93-78.018-78.018zM57.338 512c0-39.026 31.636-70.662 70.662-70.662s70.662 31.636 70.662 70.662c0 39.026-31.636 70.662-70.662 70.662s-70.662-31.636-70.662-70.662zM176.472 240.472c0 0 0 0 0 0 0-35.346 28.654-64 64-64s64 28.654 64 64c0 0 0 0 0 0 0 35.346-28.654 64-64 64s-64-28.654-64-64zM899.464 240.472c0 64.024-51.906 115.934-115.936 115.934-64.024 0-115.936-51.91-115.936-115.934 0-64.032 51.912-115.934 115.936-115.934 64.030 0 115.936 51.902 115.936 115.934z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "somi-controller-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "somi-controller",
    class: {
      'somi-hide': _vm.player.controller.hide
    }
  }, [_c('div', {
    staticClass: "somi-slider-bar",
    on: {
      "mousedown": _vm.sliderDown,
      "mouseenter": _vm.sliderEnter
    }
  }, [_c('div', {
    staticClass: "somi-slider-played",
    style: (_vm.playedStyle)
  }), _vm._v(" "), _vm._l((_vm.player.controller.sliderBar.bufferedStyles), function(bufferedStyle) {
    return _c('div', {
      staticClass: "somi-slider-buffered",
      style: (bufferedStyle)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "somi-slider-preview-box",
    style: (_vm.getSliderHoverLeft)
  }), _vm._v(" "), _c('span', {
    staticClass: "somi-slider-currentTime",
    style: (_vm.getSliderHoverLeft)
  }, [_vm._v("\n                    " + _vm._s(_vm.getSliderCurrentTime) + "\n                ")])], 2), _vm._v(" "), _c('button', {
    staticClass: "somi-main-button",
    on: {
      "click": _vm.playVideo
    }
  }, [_c('svg', {
    staticClass: "main-button-svg",
    class: {
      'button-play': _vm.player.paused, 'button-paused': !_vm.player.paused
    },
    attrs: {
      "height": "100%",
      "version": "1.1",
      "viewBox": "0 0 36 36",
      "width": "100%"
    }
  }, [_c('path', {
    staticClass: "play-svg-fill",
    attrs: {
      "d": _vm.getMainButtonSvgD,
      "id": "ytp-svg-477"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "somi-volume-container"
  }, [_c('button', {
    staticClass: "somi-volume",
    on: {
      "click": _vm.v_setMuted
    }
  }, [_c('svg', {
    staticClass: "icon-volume",
    attrs: {
      "viewBox": "-20 -24 100 110",
      "fill": "currentColor",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#fff",
      "d": _vm.getVolumeSvgD
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "somi-volume-slider-container",
    on: {
      "!mousedown": function($event) {
        return _vm.volumeSliderDown($event)
      }
    }
  }, [_c('div', {
    staticClass: "somi-total-volume"
  }, [_c('div', {
    style: (_vm.player.controller.volume.slider.class),
    attrs: {
      "claSS": "somi-current-volume"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "videoTime"
  }, [_c('span', {
    staticClass: "videoCurrentTime"
  }, [_vm._v(_vm._s(_vm.stringCurrentTime))]), _vm._v(" "), _c('span', {}, [_vm._v("/")]), _vm._v(" "), _c('span', {
    staticClass: "videoTotalTime"
  }, [_vm._v(_vm._s(_vm.stringDuration))])]), _vm._v(" "), _c('button', {
    staticClass: "somi-fullScreen-button",
    on: {
      "click": _vm.fullScreen
    }
  }, [_c('svg', {
    staticClass: "svg-fullScreen",
    class: {
      fullScreen: _vm.player.fullScreen
    },
    attrs: {
      "height": "100%",
      "version": "1.1",
      "viewBox": "0 0 36 36",
      "width": "100%"
    }
  }, [_c('g', {
    staticClass: "ytp-fullscreen-button-corner-0"
  }, [_c('path', {
    staticClass: "ytp-svg-fill",
    attrs: {
      "d": "m 10,16 2,0 0,-4 4,0 0,-2 L 10,10 l 0,6 0,0 z",
      "id": "ytp-svg-19"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "ytp-fullscreen-button-corner-1"
  }, [_c('path', {
    staticClass: "ytp-svg-fill",
    attrs: {
      "d": "m 20,10 0,2 4,0 0,4 2,0 L 26,10 l -6,0 0,0 z",
      "id": "ytp-svg-20"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "ytp-fullscreen-button-corner-2"
  }, [_c('path', {
    staticClass: "ytp-svg-fill",
    attrs: {
      "d": "m 24,24 -4,0 0,2 L 26,26 l 0,-6 -2,0 0,4 0,0 z",
      "id": "ytp-svg-21"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "ytp-fullscreen-button-corner-3"
  }, [_c('path', {
    staticClass: "ytp-svg-fill",
    attrs: {
      "d": "M 12,20 10,20 10,26 l 6,0 0,-2 -4,0 0,-4 0,0 z",
      "id": "ytp-svg-22"
    }
  })])])])])]), _vm._v(" "), _c('video', {
    staticClass: "somi-main-video",
    attrs: {
      "id": "mainVideo",
      "src": _vm.player.videoUrl
    },
    on: {
      "loadstart": _vm.v_loadstart,
      "loadedmetadata": _vm.v_loadedmetadata,
      "waiting": _vm.v_waiting,
      "canplay": _vm.v_canplay,
      "play": _vm.v_play,
      "pause": _vm.v_pause,
      "timeupdate": _vm.v_timeupdate,
      "progress": _vm.v_progress,
      "volumechange": _vm.v_volumechange,
      "error": _vm.v_error
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://vuejs.org/"
    }
  }, [_vm._v("Vue")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/SomiFrame/VueVideo"
    }
  }, [_vm._v("GitHub_Somi")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dba0faa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoPlayer.vue
// module id = 26
// module chunks = 1